import { Button } from 'react-bootstrap';
import React, { useState } from 'react';
import { ApiWebhook, ApiWebhookRequest, ApiWebhookRequestStatus } from '../api';
import { WebhookRequestModal } from './requests/WebhookRequestModal';
import { webhookApi } from '../apis';

export interface WebhookTestProps {
  webhook: ApiWebhook;
}

export const WebhookTest = ({ webhook }: WebhookTestProps) => {
  const [showModal, setShowModal] = useState(false);
  const initialWebhookRequest: ApiWebhookRequest = {
    createdTime: new Date(),
    requestContent: '',
    webhookId: webhook.id,
    trigger: webhook.trigger,
    url: webhook.url,
    status: ApiWebhookRequestStatus.NEW,
    token: webhook.token,
  };
  const [webhookRequest, setWebhookRequest] = useState<ApiWebhookRequest>(initialWebhookRequest);

  const onTestWebhook = async () => {
    setShowModal(true);
    const sentWebhookRequest = await webhookApi.testWebhook({
      webhookId: webhook.id,
    });
    setWebhookRequest(sentWebhookRequest);
  };

  const onComplete = () => {
    setShowModal(false);
    setWebhookRequest(initialWebhookRequest);
  };

  return (
    <>
      <Button onClick={onTestWebhook} className='dropdown-item' variant='outline-info'>
        Test
      </Button>
      <WebhookRequestModal show={showModal} request={webhookRequest} onComplete={onComplete} isTestRequest={true} />
    </>
  );
};
